module.exports = __webpack_public_path__ + "img/ZG81_01.ad0b7d81.jpg";